import React, { useContext, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";

// Contexts
import AuthContext from "../../context/auth/AuthContext";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated, loading, loadUser } = useContext(AuthContext);

  useEffect(() => {
    loadUser();
  }, []);

  return (
    <div>
      <Route
        {...rest}
        render={(props) =>
          loading ? (
            <div> </div>
          ) 
          : !isAuthenticated ? (
            <Redirect to="/login" />
          ) 
          : (
            <Component {...props} />
          )
        }
      />{" "}
    </div>
  );
};

export default PrivateRoute;
